import { render, staticRenderFns } from "./jiaoyiTable1.vue?vue&type=template&id=37aaf72a"
import script from "./jiaoyiTable1.vue?vue&type=script&lang=js"
export * from "./jiaoyiTable1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/check/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37aaf72a')) {
      api.createRecord('37aaf72a', component.options)
    } else {
      api.reload('37aaf72a', component.options)
    }
    module.hot.accept("./jiaoyiTable1.vue?vue&type=template&id=37aaf72a", function () {
      api.rerender('37aaf72a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Widget/jiaoyiTable1.vue"
export default component.exports